module.exports = __webpack_public_path__ + "img/smartwatch-icon.326351e8.svg";